import React, { useCallback, useState } from 'react'

import { type WidgetDTO } from '../../../../../model/Widget'

import { HubspotEditMode, type HubspotFormValues } from './edit/HubspotEditMode'
import { HubspotPreview } from './preview/HubspotPreview'

import './WidgetHubspot.scss'

interface WidgetHubspotProps {
  widget: WidgetDTO
  isEditable?: boolean
  onSave?: (values: Partial<WidgetDTO>) => Promise<void>
  onDelete?: () => void
  onCancel?: () => void
}

const WidgetHubspot = ({
  widget,
  isEditable = false,
  onSave,
  onDelete,
  onCancel,
}: WidgetHubspotProps) => {
  const [isEditMode, setIsEditMode] = useState(!!widget.empty_p)

  const handleEdit = useCallback(() => {
    setIsEditMode(true)
  }, [])

  const handleCancel = useCallback(() => {
    onCancel?.()
    if (!widget.empty_p) {
      setIsEditMode(false)
    }
  }, [onCancel, widget.empty_p])

  const handleSubmit = useCallback(
    async (values: HubspotFormValues) => {
      await onSave?.({ link: values.link })
      setIsEditMode(false)
    },
    [onSave]
  )

  const handleDelete = useCallback(() => {
    onDelete?.()
  }, [onDelete])

  return isEditMode ? (
    <HubspotEditMode
      widget={widget}
      onSave={handleSubmit}
      onCancel={handleCancel}
    />
  ) : (
    <HubspotPreview
      widget={widget}
      isEditable={isEditable}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
    />
  )
}

export { WidgetHubspot }
